<template>
  <div class="ai-resume-container">
    <pc-navbar />
    <div class="bg-cover">
      <div v-for="i in 10" :key="i" class="bg-cover-item">
        <img
          :src="
            i % 2 === 0
              ? 'https://logo.wondercv.com/banners/H4ebMnb4QfkUvAy.png'
              : 'https://logo.wondercv.com/banners/Fcg3vGErlTt8rHN.png'
          "
          alt=""
        />
      </div>
    </div>
    <div class="talking-container">
      <MessageItem
        type="text"
        content="你好，我是超级简历WonderCV AI，请完成以下选项，我们将根据你的信息为你生成专属简历，你提供的信息越详细，生成的简历会越准确。"
        :marginTop="0"
      />
      <MessageItem
        title="请选择你的身份："
        type="singlePicker"
        payload-key="identity"
        :marginTop="16"
        :active-value="payload.identity"
        :options="IDENTITY_OPTIONS"
        @confirm="confirm"
      />
      <template v-if="payload.identity">
        <MessageItem
          type="text"
          :content="`我是${payload.identity === 'student' ? '学生' : '职场人'}`"
          self
        />
        <template v-for="(item, index) in steps">
          <div v-if="index <= step" class="step-item" :key="index">
            <MessageItem
              :type="chatConfig[item.key].type"
              :input-type="chatConfig[item.key].inputType"
              :title="item.text"
              :placeholder="chatConfig[item.key].placeholder"
              :payload-key="item.key"
              :options="item.value"
              :select-options="
                item.key === 'industry'
                  ? industries
                  : item.key === 'profession'
                  ? professions
                  : []
              "
              :active-value="payload[item.key]"
              :jump="item.jump"
              :current-step="index"
              :z-index="33 - index"
              @confirm="confirm"
            />
            <MessageItem
              v-if="payload[item.key]"
              type="text"
              :content="
                payload[item.key] === 'skip'
                  ? '当前跳过该选项'
                  : `${chatConfig[item.key].content.replace(
                      '%s',
                      payload[item.key]
                    )}`
              "
              self
            />
          </div>
        </template>
        <MessageItem
          v-if="step === steps.length"
          type="over"
          content="智能简历已生成"
          @clickViewResult="clickViewResult"
        />
      </template>
    </div>
    <div v-if="createResumeLoading" class="create-resume-loading">
      <img src="https://logo.wondercv.com/banners/rAghYlVaIKQSdfY.gif" alt="">
    </div>
    <NoCountModal v-if="noCountModalVisible" @more="handleMore" @know="handleKnow" />
    <PayAlert v-if="payAlertVisible" @close="payAlertVisible = false" />
  </div>
</template>
<script>
import api from "@/api/index";
import PcNavbar from "@/components/base/navbar";
import MessageItem from "./components/MessageItem.vue";
import NoCountModal from "./components/NoCountModal.vue";
import PayAlert from '../account/user/payAlert.vue'

const IDENTITY_OPTIONS = [
  { text: "学生", value: "student" },
  { text: "职场人", value: "worker" },
];

const CHAT_CONFIG = {
  major: {
    content: "我所学的专业是%s",
    type: "inputSinglePicker",
    placeholder: "请输入专业",
    inputType: "btn",
  },
  profession: {
    content: "我想要找%s相关的工作",
    type: "multiLevelPicker",
    placeholder: "请选择职业方向",
  },
  orgs: {
    content: "我参加过的校园活动有%s",
    type: "multiPickerInput",
    placeholder: "请输入完成，回车添加",
    inputType: "enter",
  },
  soft_skills: {
    content: "我具有%s的性格特征",
    type: "multiPicker",
  },
  certificates: {
    content: "我获得过%s的资格证书",
    type: "multiPickerInput",
    placeholder: "请输入完成，回车添加",
    inputType: "enter",
  },
  honors: {
    content: "我获得过%s的荣誉奖项",
    type: "multiPickerInput",
    placeholder: "请输入完成，回车添加",
    inputType: "enter",
  },
  skill: {
    content: "我具有%s的职场软技能",
    type: "multiPicker",
  },
  work_years: {
    type: "singlePicker",
    content: "我的就业年限是%s",
  },
  industry: {
    type: "singlePickerSelect",
    content: "我的行业类型是%s",
    placeholder: "请选择行业类型",
  },
};

export default {
  name: "AiResume",
  components: {
    PcNavbar,
    MessageItem,
    NoCountModal,
    PayAlert,
  },
  data() {
    return {
      payload: {
        identity: "",
      },
      IDENTITY_OPTIONS,
      professions: [],
      industries: [],
      chatConfig: CHAT_CONFIG,
      step: -1,
      stepData: {
        student: [],
        worker: [],
      },
      createResumeLoading: false,
      noCountModalVisible: false,
      payAlertVisible: false,
    };
  },
  computed: {
    steps() {
      return this.payload.identity ? this.stepData[this.payload.identity] : [];
    },
  },
  methods: {
    handleMore() {
      window.location.href = '/jianlimoban/'
    },
    handleKnow() {
      window.location.href = '/cvs'
    },
    async clickViewResult() {
      try {
        const { identity, ...rest } = this.payload;
        const params = {
          ...rest,
          identity: IDENTITY_OPTIONS.find((item) => item.value === identity)
            .text,
        };
        for (const key in params) {
          if (params[key] === "skip") {
            params[key] = "";
          }
        }
        this.createResumeLoading = true;
        const res = await api.AI.createAiResume(params)
        if (res.code === 1000) {
          window.location.href = `/cvs/${res.data.cv_token}/editor`
        } else {
          this.$message.error(res.message)
          switch (res.code) {
            case 3001:
              this.payAlertVisible = true;
              break;
            case 3003:
              this.noCountModalVisible = true;
              break
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.createResumeLoading = false;
      }
    },
    confirm(item, key, clickStep) {
      const value = item instanceof Object ? item.value : item;
      this.payload[key] = value;
      this.$forceUpdate();
      if (key === "identity") {
        this.step = 0;
        Object.keys(this.payload).forEach((key) => {
          if (key !== "identity") this.payload[key] = "";
        });
        this.resetValue = true;
        this.$nextTick(() => {
          this.resetValue = false;
        });
      } else if (clickStep === this.step) {
        this.step++;
      }
    },
    async getProfessions() {
      try {
        const res = await api.staticApi.getProfessionsTree();
        if (res.code === 1000) {
          this.professions = res.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getIndustryList() {
      try {
        const res = await api.recruit.get_industries_list();
        if (res.code === 1000) {
          this.industries = res.data.map((item) => ({
            ...item,
            title: item.cn,
          }));
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getAiResumeChatList() {
      try {
        const res = await api.AI.fetchAiResumeChatList();
        if (res.code === 1000) {
          this.stepData = res.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    this.getProfessions();
    this.getIndustryList();
    this.getAiResumeChatList();
  },
};
</script>
<style lang="scss" scoped>
.ai-resume-container {
  position: relative;
  min-height: 100vh;
  background-color: #191c20;
  overflow: hidden;
  padding-top: 153px;
  box-sizing: border-box;
  padding-bottom: 400px;
  .bg-cover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 1000vh;
    padding-top: 256px;
    .bg-cover-item {
      width: 100%;
      &:nth-child(2n) {
        display: flex;
        justify-content: flex-end;
      }
      img {
        width: 246px;
        height: 369px;
        object-fit: contain;
      }
    }
  }
  .talking-container {
    position: relative;
    z-index: 1;
    width: 800px;
    margin: 0 auto;
  }
  .create-resume-loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 29;
    img {
      width: 200px;
      height: 200px;
    }
  }
}
</style>

